import React, { useState } from 'react';
import { TextField, Typography } from '@material-ui/core';
import { validateDateOfBirth } from '../../util/validation';
import { useValidationWarningStyles } from '../../util/styles';

const DOBOverride = ({ overrideChange, currentValue, columnKey }) => {
  const classes = useValidationWarningStyles();
  const selectedDate = currentValue
    ? new Date(currentValue)
    : new Date(new Date().setFullYear(new Date().getFullYear() - 18));

  const [warning, setWarning] = useState(validateDateOfBirth(currentValue));

  const handleChange = e => {
    if (e.target.value) {
      const newDate = new Date(e.target.value);
      overrideChange(columnKey, newDate);
      setWarning(validateDateOfBirth(newDate));
    }
  };

  return (
    <div>
      <TextField
        type="date"
        label="Date of Birth"
        defaultValue={selectedDate.toISOString().split('T')[0]}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
      {warning && <Typography className={classes.warningText}>{warning}</Typography>}
    </div>
  );
};

export { DOBOverride };
